import FormFields from "components/Form";
import SaveButton from "components/SaveButton";
import React, { useState } from "react";
import { countries } from "countries-list";
import Toast from "utils";
import { postData } from "utils/queries";
import 'react-phone-number-input/style.css'; // Optional for default styling


const defaultSettings = {
  name: "",
  phone_no: "",
  country: { value: 'GB', label: 'United Kingdom' }, // Default country value
};

const Settings = () => {
  const [settings, setSettings] = useState(defaultSettings);
  

  const handleSettingsChange = (label) => {
    return (e) => {
      console.log("checking settings", e);

      if (label == "country" || label=="phone_no") {
        setSettings({ ...settings, [label]: e });
      } else {
        setSettings({ ...settings, [label]: e?.target?.value });
      }
    };
  };

  console.log("details",settings)

  const countryOptions = Object.entries(countries).map(([code, { name }]) => ({
    value: code,
    label: name,
  }));

  const validatePhone = (value) => {
    const phonePattern = /^(?:44|0)[1-9]\d{4,14}$/;
    if (!phonePattern.test(value)) {
      return false;
    }
    return true;
  };

  const SettingsFields = [
    {
      label: "Organiser name",
      id: "name",
      placeholder: "Enter Name",
      type: "text",
      value: settings?.name,
      required: true,
      onChange: handleSettingsChange("name"),
    },
    {
      label: "Phone Number",
      id: "phone_no",
      placeholder: "Enter Phone Number",
      type: "phone_number",
      value: settings?.phone_no,
      required: true,
      onkeydown: (e)=>{
        console.log("keydown",e)
      },
      onChange: handleSettingsChange("phone_no"),
    },
    {
      label: "Country",
      id: "country",
      placeholder: "Select Country",
      type: "select",
      isDisabled:true,
      options: countryOptions,
      value: settings?.country,
      required: true,
      onChange: (e) => handleSettingsChange("country")(e),
    },
  ];

  const cancelTicket = (e) => {
    setSettings(defaultSettings);
  };

  const firstButtonArgs = {
    label: "Save",
    id: "save",
    type: "submit",
    buttonOverrideInlineStyle: { marginRight: "3rem", backgroundcolor:" #0ad5c9 "},
  };
  const secondButtonArgs = {
    label: "Cancel",
    id: "cancel",
    type: "button",
    onClick: cancelTicket,
  };

  const handleSave = async (e) => {
    e?.preventDefault();
    // if (!validatePhone(settings?.phone_no)) {
    //   return Toast().Error("Please Provide Valid Phone Number");
    // }

    try {
      const result = await postData(`organisers/`, {
        ...settings,
        country: settings?.country?.label,
      });

      if (result?.status == 201) {
        setSettings(defaultSettings);
      }
    } catch (error) {}
  };

  return (
    <>
      <form onSubmit={handleSave}>
        <FormFields Fields={SettingsFields} />

        <SaveButton
          firstButtonArgs={firstButtonArgs}
          secondButtonArgs={secondButtonArgs}
        />
      </form>
    </>
  );
};

export default Settings;
